/**
 * Tool Generation API
 * AI-assisted tool description generation from original descriptions
 */

import apiClient from './client';

// ============================================================================
// Types
// ============================================================================

// Reference tool for context
export interface ReferenceToolConfig {
  tool_name: string;
  original_description?: string;
  display_name_cn?: string;
  display_name_en?: string;
  description_cn?: string;
  description_en?: string;
}

export interface ToolDescriptionGenerateRequest {
  tool_name: string;
  original_description: string;
  category?: string;
  model: string;
  language?: string;
  // Reference tools from same group/category for consistency
  reference_tools?: ReferenceToolConfig[];
}

export interface ToolDescriptionGenerateResponse {
  display_name_cn: string;
  display_name_en: string;
  description_cn: string;
  description_en: string;
  icon_suggestion: string;
  explanation: string;
}

// ============================================================================
// API Client
// ============================================================================

export const toolGenerationApi = {
  /**
   * Generate user-friendly tool descriptions from technical descriptions using AI
   */
  generate: async (
    data: ToolDescriptionGenerateRequest
  ): Promise<ToolDescriptionGenerateResponse> => {
    const response = await apiClient.post<ToolDescriptionGenerateResponse>(
      '/tool-generation/generate',
      data
    );
    return response.data;
  },
};
